import { getData, downloadData, gridList } from "@/api/listdata"
import Crypto from "@/components/Aes"

const state = {
  listdatas: [],
  clicknode: '',
  orderdatas: [],
}

const mutations = {
  SET_TREEDATA: (state, listdatas) => {
    state.listdatas = listdatas 
  },
  SET_CLICKNODE: (state, clicknode) => {
    state.clicknode = clicknode
  },
  SET_ORDERDATA: (state, downloaddata) => {
    state.orderdatas = downloaddata
  },
}

const actions = {
  grid_list({ commit }, nodes) {
    return new Promise((resolve, reject) => {
      gridList(nodes.pid).then(
        res => {
          const data=JSON.parse(res.data)
          commit('SET_TREEDATA', data)
          commit('SET_CLICKNODE',nodes)
          resolve()
        }
      ).catch(err => {
        reject(err)
      })
    })
  },

  listdata({ commit }, nodes) {
    return new Promise((resolve, reject) => {
      getData(nodes.newpid).then(
        res => {
          let destr = Crypto.get(res.data)
          const data=JSON.parse(destr)
          commit('SET_TREEDATA', data)
          commit('SET_CLICKNODE', nodes)
          resolve()
        }
      ).catch(error => {
        reject(error)
      })
    })
  },
  orderdata({ commit }, params) {
    return new Promise((resolve, reject) => {
      downloadData(params).then(
        res => {
          let destr = Crypto.get(res.data)
          const data =JSON.parse(destr)
          commit('SET_ORDERDATA',data)
          resolve()
        }
      ).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/listdata.js